module.exports = __webpack_public_path__ + "0f8ccdb8e8126fc08f026aa0032be4ec.svg";